<template>
  <section>
    <!-- SNACKBAR -->
    <v-snackbar
      v-model="snackbar.show"
      :timeout="10000"
      multi-line
      left
      top
      :color="snackbar.color"
    >
      {{ snackbar.text }}
      <v-btn
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>

      <div class="action--create-basic">
        <v-alert
          :value="err"
          type="error"
          v-if="err"
        >
          {{ err.graphQLErrors.length > 0 ? err.graphQLErrors[0].data.message : err.message }}
        </v-alert>
        <v-card class="action--create-card">
          <v-form v-model="valid" @submit="createRole">
            <p>CREATE ROLE</p>
            <div class="action--create-pd">
              <div class="action--create-grid-2">
                <div>
                  <v-text-field label="Name" v-model="form.name" :rules="nameRules" />
                </div>
                <div>
                <v-autocomplete
                  :loading="loading"
                  :items="actions"
                  item-text="text"
                  flat
                  label="ACTIONS"
                  :rules="actionRules"
                  v-model="form.action"
                  :search-input.sync="search"
                  clearable
                  persistent-hint
                  allow-overflow
                  return-object
                  multiple
                />
                </div>
              </div>
            </div>

            <div>
              <v-btn color="primary" large block depressed :disabled="!valid" type="submit">Save</v-btn>
            </div>
          </v-form>
        </v-card>
      </div>
  </section>
</template>

<script>
import { coreClient } from "../../../apollo";
import gql from "graphql-tag";
export default {
  name: "CreateRole",
  data() {
    return {
      err: "",
      snackbar: {
        show: false,
        color: "",
        text: ""
      },
      actions: [],
      form: {
        name: "",
        action: []
      },
      valid: false,
      search: "",
      loading: false,
      actionRules: [v => !!v || "The action is required."],
      nameRules: [
        v => !!v || "The name is required.",
        v => v.length > 2 || "The name must be atleast 2 characters."
      ]
    };
  },
  watch: {
    async search(v) {
      this.loading = true;
      v && v !== this.form.action && (await this.getActions({ name: v }));
      this.loading = false;
    }
  },
  methods: {
    async getActions(variables = {}) {
      try {
        const { data } = await coreClient.query({
          query: gql`
            query Actions($name: String, $page: Int, $limit: Int) {
              Actions(name: $name, page: $page, limit: $limit) {
                total
                pages
                page
                docs {
                  id
                  name
                  resource {
                    id
                    name
                  }
                }
              }
            }
          `,
          variables: {
            ...variables,
            limit: 30
          }
        });

        this.actions = data.Actions.docs.map(doc => {
          doc.text = `${doc.name}/${doc.resource.name}`;
          return doc;
        });
      } catch (err) {
        this.snackbar = {
          text:
            err.graphQLErrors.length > 0
              ? err.graphQLErrors[0].data.message
              : err.message,
          show: true,
          color: "error"
        };
        this.err = err;
      }
    },
    async createRole(e) {
      e.preventDefault();
      try {
        const { data } = await coreClient.mutate({
          mutation: gql`
            mutation createRole($name: String!, $action: [String!]!) {
              createRole(name: $name, actions: $action) {
                id
              }
            }
          `,
          variables: {
            ...this.form,
            action: this.form.action.map(action => action.id)
          }
        });

        const { createRole } = data;

        this.snackbar = {
          show: true,
          color: "success",
          text: "The Role was created."
        };

        setTimeout(() => {
          this.$router.push("/authentication/role/" + createRole.id);
        }, 500);
      } catch (err) {
        this.snackbar = {
          text:
            err.graphQLErrors.length > 0
              ? err.graphQLErrors[0].data.message
              : err.message,
          show: true,
          color: "error"
        };

        this.err = err;
      }
    }
  },
  async mounted() {
    await this.getActions();
  }
};
</script>

<style lang="stylus" scoped>
@import '../../../assets/stylus/Action_create.styl';

.action--create-card {
  min-width: 800px;
}
</style>
